import "rxjs"
import $ from "jquery"
import {ajax} from "rxjs/observable/dom/ajax"
import config from "../config"
import errorHandlerBuilder from "./errorHandlerBuilder"
import {
  ACTION_ENTERPRISE_ACCOUNT_LIST_LOADED,
  ACTION_ENTERPRISE_ACCOUNT_LIST_LOADING,
  ACTION_ENTERPRISE_ACCOUNT_LIST_ERROR,
  PATH_ENTERPRISE_ACCOUNTS
} from "../constants"

const api_server_host = config.api_server_host

const errorHandler = errorHandlerBuilder(ACTION_ENTERPRISE_ACCOUNT_LIST_ERROR)

const epic = (action$, store)=>
  action$.ofType(ACTION_ENTERPRISE_ACCOUNT_LIST_LOADING)
    .mergeMap(action => {

      const tokenData = store.getState().user
      const token = tokenData.access_token
      const type = tokenData.token_type

      const params = action.payload

      return ajax({
        method: 'GET',
        url: `${api_server_host}${PATH_ENTERPRISE_ACCOUNTS}?${$.param(params)}`,
        headers: {
          Authorization: `${type} ${token}`
        },
        responseType: 'json'
      }).map(data=> {

        return {
          type: ACTION_ENTERPRISE_ACCOUNT_LIST_LOADED,
          payload: data.response
        }
      }).catch(errorHandler)

    })

export default epic



// WEBPACK FOOTER //
// ./src/epics/EnterpriseAccountListEpic.js